var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62509 10.5705L3.45634 8.40175C3.33948 8.28489 3.18098 8.21924 3.01572 8.21924C2.85045 8.21924 2.69195 8.28489 2.57509 8.40175C2.45823 8.51861 2.39258 8.67711 2.39258 8.84238C2.39258 8.92421 2.4087 9.00524 2.44001 9.08084C2.47133 9.15644 2.51723 9.22514 2.57509 9.283L5.18759 11.8955C5.43134 12.1393 5.82509 12.1393 6.06884 11.8955L12.6813 5.283C12.7982 5.16614 12.8639 5.00764 12.8639 4.84238C12.8639 4.67711 12.7982 4.51861 12.6813 4.40175C12.5645 4.28489 12.406 4.21924 12.2407 4.21924C12.0754 4.21924 11.917 4.28489 11.8001 4.40175L5.62509 10.5705Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveredIcon);
export default __webpack_public_path__ + "static/media/deliveredIcon.e5794538830970c122f84ef0337a4fda.svg";
export { ForwardRef as ReactComponent };